// Example API service for auth endpoints
import api from "./api.ts";

export const register = (email: string, password: string, country: string, termsAccepted: boolean) =>
  api.post("/auth/register", { email, password, country, terms_accepted: termsAccepted });

export const getRegistrationStatus = (email: string) =>
  api.get("/auth/status", { params: { email } });

export const login = (email: string, password: string) =>
  api.post("/auth/login", { email, password });

export const forgotPassword = (email: string) =>
  api.post("/auth/forgot-password", { email });

export const resetPassword = (email: string, code: string, newPassword: string) =>
  api.post("/auth/reset-password", { email, code, new_password: newPassword });

export const changePassword = (currentPassword: string, newPassword: string) => {
  const token = localStorage.getItem("token");
  return api.post(
    "/auth/change-password",
    { current_password: currentPassword, new_password: newPassword },
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
};
